import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500">韩漫在线</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : scrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white hover:text-primary-300"
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith("/category")
                  ? "text-primary-500"
                  : scrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white hover:text-primary-300"
              }`}
            >
              漫画分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : scrolled || !isHome
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white hover:text-primary-300"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-search-line text-foreground-600"></i>
            </button>
            <button className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer">
              开始阅读
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          >
            <i
              className={`text-xl ${
                scrolled || !isHome ? "text-foreground-800" : "text-white"
              } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 cursor-pointer ${
                location.pathname === "/" ? "text-primary-500" : "text-foreground-700"
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium py-2 cursor-pointer ${
                location.pathname.startsWith("/category") ? "text-primary-500" : "text-foreground-700"
              }`}
            >
              漫画分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 cursor-pointer ${
                location.pathname === "/about" ? "text-primary-500" : "text-foreground-700"
              }`}
            >
              关于我们
            </Link>
            <button className="mt-2 px-6 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer w-fit">
              开始阅读
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}